/* eslint-disable import/no-cycle */
import Vue from 'vue';
import Vuex from 'vuex';
import smart from "../store/modules/smart.js"
import bot from "../store/modules/bot.js"
// eslint-disable-next-line import/no-cycle


Vue.use(Vuex);
export default new Vuex.Store({
    state: {

    },
    mutations: {},
    actions: {

    },
    modules: {
      smart,
      bot

    },
});
